import { anatomyModule } from "./anatomy";
import { anatomy2Module } from "./anatomy2";
import { histologyModule } from "./histology";
import { physiologyModule } from "./physiology";
import { diseaseModule } from "./disease";
import { disease2Module } from "./disease2";
import { pharmacologyModule } from "./pharmacology";
import { surgeryModule } from "./surgery";
import { surgery2Module } from "./surgery2";

export const thyroidModules = [anatomyModule, anatomy2Module, histologyModule, physiologyModule, diseaseModule, disease2Module, pharmacologyModule, surgeryModule, surgery2Module];
